export default "__VITE_ASSET__BXLWtCLW__"